import clsx from 'clsx'

import { DeliveryMethod } from 'modules/delivery'

import { ProductAvailabilityPlan } from '../../types/products'

import DeliveryMethodBox from './DeliveryMethodBox'

import styles from './AvailabilityCalendar.module.scss'

interface AvailabilityCalendarProps
  extends React.HTMLAttributes<HTMLDivElement> {
  calendar: ProductAvailabilityPlan
  deliveryMethods: DeliveryMethod[]
}

const AvailabilityCalendar = ({
  calendar,
  deliveryMethods,
  className,
  ...props
}: AvailabilityCalendarProps) => {
  return (
    <div className={clsx(styles.wrapper, className)} {...props}>
      {deliveryMethods.map(deliveryMethod => (
        <DeliveryMethodBox
          key={deliveryMethod.id}
          deliveryMethod={deliveryMethod}
          calendar={calendar}
        />
      ))}
    </div>
  )
}

export default AvailabilityCalendar
